import { useState } from "react";
import axios from "axios";
import { useForm, useFormState } from "react-hook-form";
import { IoTicket } from "react-icons/io5";
import { FaRegCheckCircle } from "react-icons/fa";
import { FaCheck } from "react-icons/fa";
import ArrowYellow from "../../img/arrow-yellow.png"

export default function Form(page) {

    const {
        register,
        handleSubmit,
        watch,
        formState: { errors, isSubmitSuccessful, isSubmitted , isSubmitting}
    } = useForm();

    const [preloader, preloaderFormStyle] = useState('hidden');
    const [promoAlert, setPromoAlertData] = useState('');
    const [promoAlertStyle, setPromoAlerStyle] = useState('');

    const [event, setEvent] = useState({});

    const clearDataPromo = async (data) => {

        var promocodeData = {
            promocode: data,
            site_name : domain,
            action: 'checkpromo'
        }

        try {
            const response = await axios.post(
                'https://ekonomika.ua/wp-content/plugins/ekonomika-workandbusiness/ekonomika-requests.php',
                promocodeData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
            if (response.status === 201 || response.status === 200) {
                if(response.data.check === false) {
                    setPromoAlertData(response.data.message);
                    setPromoAlerStyle(errorStyle);
                } else {
                    setPromoAlertData(FaCheck);
                    setPromoAlerStyle(successStyle);
                }
            }
        } catch (error) {
            console.error('Error:', error);
        }
    }

    const onSubmit = async (data) => {

        try {

            preloaderFormStyle('flex');

            const response = await axios.post(
                'https://ekonomika.ua/wp-content/plugins/ekonomika-workandbusiness/ekonomika-requests.php',
                data, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });

            // Check if response is successful
            if(response.data.check !== false) {
                if (response.status === 201) {
                    //console.log(response.data);
                    window.location.href = '/congratulation';
                } else {
                    //console.log(response.data);
                    window.location.href = '/congratulation';
                }
            }

        } catch (error) {
            console.error('Error:', error);
        } finally {
            preloaderFormStyle('hidden');
        }
    };

    const normalizeTel = (value) => {
        value = value.replace(/\D/g, "");
        value = value.replace(/^(\d{3})(\d)/g, "($1) $2");
        if(value.length < 14) {
            value = value.replace(/(\d{3})(\d{2})(\d{2})$/, "$1-$2-$3");
        } else {
            value = value.replace(/(\d{3})(\d{2})(\d{2})(\d{2})$/, "$1-$2-$3-$4");
        }
        return value;
    };

    const errorStyle = "absolute -top-3 right-0 text-[13px] text-red-800 z-10 bg-white text-sm p-[4px] leading-none flex items-center items-center";
    const successStyle = "absolute top-0 right-0 text-[#003366] z-10 text-sm h-full h-full p-[4px] leading-none flex items-center items-center";
    const domain =   window.location.protocol + '//' + window.location.host;

    //get url parameters
    const windowUrl = window.location.search;
    const searchParams = new URLSearchParams(windowUrl);

    const utm_source = searchParams.get("utm_source") ? searchParams.get("utm_source") : '';
    const utm_medium = searchParams.get("utm_medium") ? searchParams.get("utm_medium") : '';
    const utm_campaign = searchParams.get("utm_campaign") ? searchParams.get("utm_campaign") : '';

    return (
        <div>


            <form onSubmit={handleSubmit(onSubmit)} className="mt-4 relative">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-3">
                    <div className="w-full mb-4 relative">
                        <input type="text" name="nameu" {...register("nameu", {required: true})} placeholder="Імʼя"
                               className="bg-transparent font-light appearance-none border border-gray-300 w-full py-2 px-4 text-gray-300 leading-tight focus:outline-none focus:text-black focus:border-black"/>
                        {errors.nameu && <div className={errorStyle}>вкажіть ваше імʼя</div>}
                    </div>
                    <div className="w-full mb-4 relative">
                        <input type="email" name="email" {...register("email", {required: true})} placeholder="Пошта"
                               className="bg-transparent font-light appearance-none border border-gray-300 w-full py-2 px-4 text-gray-300 leading-tight focus:outline-none focus:text-black focus:border-black"/>
                        {errors.email && <div className={errorStyle}>вкажіть email</div>}
                    </div>
                    <div className="w-full mb-4 relative">
                        <input
                            type="text"
                            {...register("phone", {
                                required: true,
                                pattern: /^\([0-9]{3}\) [0-9]{2,5}-[0-9]{2,5}-[0-9]{2,5}-[0-9]{0,5}/ && /^\([0-9]{3}\) [0-9]{2,5}-[0-9]{2,5}-[0-9]{2,5}/
                            })}
                            maxLength="17"
                            placeholder="Тел. (099) 999-99-99"
                            onChange={(event) => {
                                const {value} = event.target;
                                event.target.value = normalizeTel(value);
                            }}
                            name="phone"
                            className={"bg-transparent font-light appearance-none border border-gray-300 w-full py-2 px-4 text-gray-300 leading-tight focus:outline-none focus:text-black focus:border-black " + (errors.phone ? "form-control text-amber-700" : "form-control")}/>
                        {errors.phone && errors.phone.type === "required" && (
                            <div className={errorStyle}>вкажіть телефон</div>
                        )}
                        {errors.phone && errors.phone.type === "pattern" && (
                            <div className={errorStyle}>вкажіть телефон</div>
                        )}
                    </div>
                    <div className="w-full mb-4 relative">
                        <input type="text" name="name_telegram" {...register("name_telegram", {required: false})} placeholder="Нік в телеграм"
                               className="bg-transparent font-light appearance-none border border-gray-300 w-full py-2 px-4 text-gray-300 leading-tight focus:outline-none focus:text-black focus:border-black"/>
                    </div>
                </div>

                <input name="page_name" {...register("page_name")} type="hidden" value={page.page}/>
                <input name="site_name" {...register("site_name")} type="hidden" value={domain}/>
                <input name="position" {...register("position")} type="hidden" value=""/>
                <input name="utm_source" {...register("utm_source")} type="hidden" value={utm_source}/>
                <input name="utm_medium" {...register("utm_medium")} type="hidden" value={utm_medium}/>
                <input name="utm_campaign" {...register("utm_campaign")} type="hidden" value={utm_campaign}/>
                <div className="grid grid-cols-2 gap-2 justify-start align-end relative">

                    <input type="submit" name="submit" value="Надіслати"
                           className="bg-[#8C98FF] leading-tight appearance-none uppercase py-2 px-4 inline-flex items-center cursor-pointer text-white"/>

                    {/*<a href="https://docs.google.com/forms/d/e/1FAIpQLSeJtqAGnS7ISi5sjtL9YVai0NlP_o5LH6O1lAdXQXny1-emVg/viewform?usp=header"*/}
                    {/*   target="_blank"*/}
                    {/*   className="text-sm text-gray-400 hover:text-white w-full font-normal py-2 inline-flex items-center cursor-pointer max-sm:col-span-2">Корпоративним*/}
                    {/*    клієнтам</a>*/}

                </div>
                <div
                    className={"absolute top-0 left-0 w-full h-full d-flex items-center justify-center bg-white/90 text-[#003366] " + preloader}>
                    <div className="flex text-2xl justify-center items-center">
                        <FaRegCheckCircle className="mr-3"/> <span>Зачекайте...</span>
                    </div>
                </div>
            </form>

        </div>

    )
}